import React from 'react';

import paginationsSet from './constants/paginationsSet';
import ShowCase from '@components/ShowCase/ShowCase';
import Preview from '@components/ShowCase/Preview/Preview';
import Controls from '@components/ShowCase/Controls/Controls';

const Paginations = () => {
  return (
    <section>
      <article>
        <ul className="showcase-list">
          {
            paginationsSet.map((paginationsPreview, i) => (
              <li key={`paginations-showcase-${i}`}>
                <ShowCase codeTemplate={paginationsPreview.codeTemplate}>
                  <Preview>
                    { paginationsPreview.component }
                  </Preview>
                  <Controls optionsGroup={paginationsPreview.optionsGroup}  />
                </ShowCase>
              </li>
            ))
          }
        </ul>
      </article>
    </section>
  );
};

Paginations.displayName = 'PaginationsPage';

export default Paginations;



// WEBPACK FOOTER //
// ./src/containers/elements/Paginations/Paginations.js